module.exports = __webpack_public_path__ + "img/logo-new.4c6c0539.svg";